// // import React from 'react';
// // import { NavLink } from 'react-router-dom';


// // const Sidebar = () => {
// //     return (
// //         <div className="sidebar">
// //             <h2>Admin Menu</h2>
// //             <ul>
// //                 <li><NavLink to="/admin/dashboard" activeClassName="active">Dashboard</NavLink></li>
// //                 <li><NavLink to="/admin/car-details" activeClassName="active">Car Details</NavLink></li>
// //                 <li><NavLink to="/admin/bookings" activeClassName="active">Bookings</NavLink></li>
// //                 <li><NavLink to="/admin/users" activeClassName="active">Users</NavLink></li>
// //                 <li><NavLink to="/admin/settings" activeClassName="active">Settings</NavLink></li>
// //             </ul>
// //         </div>
// //     );
// // };

// // export default Sidebar;

// // import React from 'react';
// // import { NavLink } from 'react-router-dom';
// // import { FaTachometerAlt, FaCar, FaShoppingCart, FaUsers, FaCog } from 'react-icons/fa';

// // const Sidebar = () => {
// //     return (
// //         <div className="bg-blue-600 text-white w-64 h-screen flex flex-col p-5 rounded-r-3xl">
// //             <h2 className="text-2xl font-bold mb-5">Admin Menu</h2>
// //             <ul className="flex-1 space-y-4">
// //                 <li>
// //                     <NavLink to="/admin/manufacture" className="flex items-center gap-3 p-3 rounded-lg hover:bg-blue-500 transition" activeClassName="bg-white text-blue-600">
// //                         <FaTachometerAlt />
// //                         Dashboard
// //                     </NavLink>
// //                 </li>
// //                 <li>
// //                     <NavLink to="/admin/car-details" className="flex items-center gap-3 p-3 rounded-lg hover:bg-blue-500 transition" activeClassName="bg-white text-blue-600">
// //                         <FaShoppingCart />
// //                         Car Details
// //                     </NavLink>
// //                 </li>
// //                 <li>
// //                     <NavLink to="/admin/bookings" className="flex items-center gap-3 p-3 rounded-lg hover:bg-blue-500 transition" activeClassName="bg-white text-blue-600">
// //                         <FaCar />
// //                         Bookings
// //                     </NavLink>
// //                 </li>
// //                 <li>
// //                     <NavLink to="/admin/users" className="flex items-center gap-3 p-3 rounded-lg hover:bg-blue-500 transition" activeClassName="bg-white text-blue-600">
// //                         <FaUsers />
// //                         Users
// //                     </NavLink>
// //                 </li>
// //                 <li>
// //                     <NavLink to="/admin/settings" className="flex items-center gap-3 p-3 rounded-lg hover:bg-blue-500 transition" activeClassName="bg-white text-blue-600">
// //                         <FaCog />
// //                         Settings
// //                     </NavLink>
// //                 </li>
// //             </ul>
// //             <div className="flex justify-center space-x-4 mt-5 text-sm">
// //                 <a href="#" className="hover:underline">Facebook</a>
// //                 <a href="#" className="hover:underline">Twitter</a>
// //                 <a href="#" className="hover:underline">Google</a>
// //             </div>
// //         </div>
// //     );
// // };

// // export default Sidebar;

// import React from 'react';
// import { NavLink, useNavigate } from 'react-router-dom';
// import { FaTachometerAlt, FaCar, FaShoppingCart, FaUsers, FaCog, FaSignOutAlt } from 'react-icons/fa';

// const Sidebar = () => {
//     const navigate = useNavigate();

//     const handleLogout = () => {
//         // Example: Clear auth data if stored
//         localStorage.removeItem('token'); // Adjust this based on your setup
//         navigate('/');
//     };

//     return (
//         <div className="bg-blue-600 text-white w-64 h-screen flex flex-col p-5 rounded-r-3xl">
//             <h2 className="text-2xl font-bold mb-5">Admin Menu</h2>
//             <ul className="flex-1 space-y-4">
//                 <li>
//                     <NavLink to="/admin/manufacture" className="flex items-center gap-3 p-3 rounded-lg hover:bg-blue-500 transition" activeClassName="bg-white text-blue-600">
//                         <FaTachometerAlt />
//                         Dashboard
//                     </NavLink>
//                 </li>
//                 <li>
//                     <NavLink to="/admin/car-details" className="flex items-center gap-3 p-3 rounded-lg hover:bg-blue-500 transition" activeClassName="bg-white text-blue-600">
//                         <FaShoppingCart />
//                         Car Details
//                     </NavLink>
//                 </li>
//                 <li>
//                     <NavLink to="/admin/bookings" className="flex items-center gap-3 p-3 rounded-lg hover:bg-blue-500 transition" activeClassName="bg-white text-blue-600">
//                         <FaCar />
//                         Bookings
//                     </NavLink>
//                 </li>
//                 {/* <li>
//                     <NavLink to="/admin/users" className="flex items-center gap-3 p-3 rounded-lg hover:bg-blue-500 transition" activeClassName="bg-white text-blue-600">
//                         <FaUsers />
//                         Users
//                     </NavLink>
//                 </li>
//                 <li>
//                     <NavLink to="/admin/settings" className="flex items-center gap-3 p-3 rounded-lg hover:bg-blue-500 transition" activeClassName="bg-white text-blue-600">
//                         <FaCog />
//                         Settings
//                     </NavLink>
//                 </li> */}
//                 <li>
//                     <button onClick={handleLogout} className="flex items-center gap-3 p-3 rounded-lg hover:bg-blue-500 transition w-full text-left">
//                         <FaSignOutAlt />
//                         Logout
//                     </button>
//                 </li>
//             </ul>
//             <div className="flex justify-center space-x-4 mt-5 text-sm">
//                 <a href="#" className="hover:underline">Facebook</a>
//                 <a href="#" className="hover:underline">Twitter</a>
//                 <a href="#" className="hover:underline">Google</a>
//             </div>
//         </div>
//     );
// };

// export default Sidebar;

import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { FaBars, FaTimes, FaTachometerAlt, FaCar, FaShoppingCart, FaSignOutAlt } from 'react-icons/fa';

const Sidebar = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/');
  };

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      {/* Hamburger for Mobile */}
      <div className="md:hidden fixed top-4 left-4 z-50">
        <button
          onClick={toggleSidebar}
          className="text-white bg-blue-600 p-2 rounded-md focus:outline-none"
        >
          {isOpen ? <FaTimes size={20} /> : <FaBars size={20} />}
        </button>
      </div>

      {/* Sidebar */}
      <div
        className={`fixed top-0 left-0 h-full bg-blue-600 text-white w-64 p-5 z-40 transform transition-transform duration-300 ease-in-out 
        ${isOpen ? 'translate-x-0' : '-translate-x-full'} md:translate-x-0 md:static md:h-screen rounded-r-3xl`}
      >
        <h2 className="text-2xl font-bold mb-5">Admin Menu</h2>
        <ul className="space-y-4">
          <li>
            <NavLink
              to="/admin/manufacture"
              className="flex items-center gap-3 p-3 rounded-lg hover:bg-blue-500 transition"
            >
              <FaTachometerAlt />
             Register
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/admin/car-details"
              className="flex items-center gap-3 p-3 rounded-lg hover:bg-blue-500 transition"
            >
              <FaShoppingCart />
              Car Details
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/admin/bookings"
              className="flex items-center gap-3 p-3 rounded-lg hover:bg-blue-500 transition"
            >
              <FaCar />
              Bookings
            </NavLink>
          </li>

          <li>
            <button
              onClick={handleLogout}
              className="flex items-center gap-3 p-3 rounded-lg hover:bg-blue-500 transition w-full text-left"
            >
              <FaSignOutAlt />
              Logout
            </button>
          </li>
        </ul>

        {/* <div className="flex  space-x-4 mt-20 text-sm">
          <a href="#" className="hover:underline">Facebook</a>
          <a href="#" className="hover:underline">Twitter</a>
          <a href="#" className="hover:underline">Google</a>
        </div> */}
      </div>

      {/* Backdrop on mobile when sidebar is open */}
      {isOpen && (
        <div
          onClick={toggleSidebar}
          className="fixed inset-0 bg-black opacity-30 z-30 md:hidden"
        ></div>
      )}
    </>
  );
};

export default Sidebar;


